import http from "../utils/http";
import { toast } from "../utils/toast";
// 증빙 자료 업로드
export const postEvidenceFiles = (prams) => {
  return new Promise((resolve, reject) => {
    http
      .post("/evidence-files", prams)
      .then((res) => {
        toast.success("증빙자료가 업로드되었습니다.");
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 증빙 자료 리스트
export const getEvidenceFilesList = (prams) => {
  return new Promise((resolve, reject) => {
    http
      .post("/evidence-files/list", prams)
      .then((res) => {
        // toast.success("증빙자료가 업로드되었습니다.");
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};
